import { IBaseMigrationStaffer } from '../../../interfaces';
import { StafferMappingHandler } from '../../../mappings/staff';
import {
  IPraktikaStaffer,
  PraktikaStaffer,
  StafferSourceEntity,
} from '../../source/entities/staff';

export class PraktikaStafferMappingHandler extends StafferMappingHandler<
  PraktikaStaffer,
  StafferSourceEntity
> {
  override sourceEntity = new StafferSourceEntity();
  translateFn = (record: IPraktikaStaffer): IBaseMigrationStaffer => ({
    id: record.id,
    name: `${record.first_name} ${record.last_name}`,
    providerNo: record.provider_number,
  });
}
